import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, requireWorkspace }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="font-heading text-2xl tracking-tight text-primary animate-pulse">alignee</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/giris" replace />;
  if (requireWorkspace && (!user.tenant_id || !user.role))
    return <Navigate to="/baslangic" replace />;
  return children;
}
